export default "__VITE_ASSET__DrTE8Saq__"